// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IRequisitesDto } from './IRequisitesDto';
import {
    IRequisitesDtoFromJSON,
    IRequisitesDtoFromJSONTyped,
    IRequisitesDtoToJSON,
    IRequisitesDtoToJSONTyped,
} from './IRequisitesDto';
import type { IDirectDepositDto } from './IDirectDepositDto';
import {
    IDirectDepositDtoFromJSON,
    IDirectDepositDtoFromJSONTyped,
    IDirectDepositDtoToJSON,
    IDirectDepositDtoToJSONTyped,
} from './IDirectDepositDto';
import type { IPaymentMethodOwnerDto } from './IPaymentMethodOwnerDto';
import {
    IPaymentMethodOwnerDtoFromJSON,
    IPaymentMethodOwnerDtoFromJSONTyped,
    IPaymentMethodOwnerDtoToJSON,
    IPaymentMethodOwnerDtoToJSONTyped,
} from './IPaymentMethodOwnerDto';

/**
 * 
 * @export
 * @interface IPaymentMethodSetupRequestDto
 */
export interface IPaymentMethodSetupRequestDto {
    /**
     * 
     * @type {string}
     * @memberof IPaymentMethodSetupRequestDto
     */
    payment_method_type?: IPaymentMethodSetupRequestDtoPaymentMethodTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof IPaymentMethodSetupRequestDto
     */
    is_default?: boolean;
    /**
     * 
     * @type {IPaymentMethodOwnerDto}
     * @memberof IPaymentMethodSetupRequestDto
     */
    payment_method_owner?: IPaymentMethodOwnerDto;
    /**
     * 
     * @type {IDirectDepositDto}
     * @memberof IPaymentMethodSetupRequestDto
     */
    direct_deposit?: IDirectDepositDto;
    /**
     * 
     * @type {IRequisitesDto}
     * @memberof IPaymentMethodSetupRequestDto
     */
    requisites?: IRequisitesDto;
    /**
     * 
     * @type {boolean}
     * @memberof IPaymentMethodSetupRequestDto
     */
    skip_notification_sending?: boolean;
}

/**
* @export
* @enum {string}
*/
export enum IPaymentMethodSetupRequestDtoPaymentMethodTypeEnum {
    DIRECT_DEPOSIT = 'DIRECT_DEPOSIT',
    DEBIT = 'DEBIT',
    VENMO = 'VENMO',
    PAYPAL = 'PAYPAL',
    CHECK = 'CHECK'
}


/**
 * Check if a given object implements the IPaymentMethodSetupRequestDto interface.
 */
export function instanceOfIPaymentMethodSetupRequestDto(value: object): value is IPaymentMethodSetupRequestDto {
    return true;
}

export function IPaymentMethodSetupRequestDtoFromJSON(json: any): IPaymentMethodSetupRequestDto {
    return IPaymentMethodSetupRequestDtoFromJSONTyped(json, false);
}

export function IPaymentMethodSetupRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPaymentMethodSetupRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'payment_method_type': json['payment_method_type'] == null ? undefined : json['payment_method_type'],
        'is_default': json['is_default'] == null ? undefined : json['is_default'],
        'payment_method_owner': json['payment_method_owner'] == null ? undefined : IPaymentMethodOwnerDtoFromJSON(json['payment_method_owner']),
        'direct_deposit': json['direct_deposit'] == null ? undefined : IDirectDepositDtoFromJSON(json['direct_deposit']),
        'requisites': json['requisites'] == null ? undefined : IRequisitesDtoFromJSON(json['requisites']),
        'skip_notification_sending': json['skip_notification_sending'] == null ? undefined : json['skip_notification_sending'],
    };
}

export function IPaymentMethodSetupRequestDtoToJSON(json: any): IPaymentMethodSetupRequestDto {
    return IPaymentMethodSetupRequestDtoToJSONTyped(json, false);
}

export function IPaymentMethodSetupRequestDtoToJSONTyped(value?: IPaymentMethodSetupRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payment_method_type': value['payment_method_type'],
        'is_default': value['is_default'],
        'payment_method_owner': IPaymentMethodOwnerDtoToJSON(value['payment_method_owner']),
        'direct_deposit': IDirectDepositDtoToJSON(value['direct_deposit']),
        'requisites': IRequisitesDtoToJSON(value['requisites']),
        'skip_notification_sending': value['skip_notification_sending'],
    };
}

